import React from "react";
import { func, bool } from "prop-types";
import "./hamburger.m.css";

const HamburgerIcon = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="30"
      viewBox="0 0 600.000000 400.000000"
      preserveAspectRatio="xMidYMid meet"
      styleName="hamburger"
    >
      <g transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
        <path
          d="M1510 2865 l0 -245 1410 0 1410 0 0 245 0 245 -1410 0 -1410 0 0
-245z"
        />
        <path
          d="M1510 2005 l0 -245 1410 0 1410 0 0 245 0 245 -1410 0 -1410 0 0
-245z"
        />
        <path
          d="M1510 1115 l0 -245 1410 0 1410 0 0 245 0 245 -1410 0 -1410 0 0
-245z"
        />
      </g>
    </svg>
  );
};

export default HamburgerIcon;

HamburgerIcon.propTypes = {
  onMenuToggle: func,
  isNavbarOpen: bool,
  isDesktop: bool
};
